import {createRoot} from "react-dom/client";
import {ReactElement} from "react";

export type RenderHandler = {
    close: () => void
}

export function renderToast(element: ReactElement) {
    let root = createRoot(document.getElementById('root_toast') as HTMLElement)
    root.render(element)

    return {
        close: async () => {
            root.unmount()
            // if (!wrapperRef.current) {
            //     // it means the wrapper is not mounted yet, call `unmount` directly
            //     unmount()
            //     // call `afterClose` to make sure the callback is called
            //     element.props.afterClose?.()
            // } else {
            //     wrapperRef.current?.close()
            // }
        },
        // replace: element => {
        //     wrapperRef.current?.replace(element)
        // },
        // isRendered: () => !!wrapperRef.current,
    } as RenderHandler
}